import { SelectionType } from "@swimlane/ngx-datatable";
import {
  ColumnTableType,
  HideShowColumn,
  SortOrder,
} from "src/components/shared-components/enum/enumTableHistory";
import { Filter } from "./filter";

export class ItemHistory {
  Id: number = -1;
  IconInfo: IconInfo = null;
  Title: TextInfo = null;
  Subtitles: Subtitle[] = [];
}

export class TextInfo {
  Text: string = "";
  CssClass: string = "";
}

export class IconInfo {
  Name: string = "";
  CssClass: string = "";
}

export class Subtitle {
  TextInfo: TextInfo = null;
  IconInfo: IconInfo = null;
}

export class Column {
  Prop: string;
  Name: string;
  Class: string;
  Type: ColumnTableType;
  Visible: HideShowColumn;
}

export class ValueToChange {
  Id: string;
  IdObj: number;
  Value: any;
}

export class TableInfo {
  Filters: Filter[]; //Filter array (default is empty), useful in history
  List: any[]; //APP: Item History list [], WEB: Row list for the table
  CssClass: string; //class to assign to the ngx-datatable
  SelectionType: SelectionType; //type of selection allowed in ngx-datatable
  Columns: Column[]; //array of columns to display in ngx-datatable
  ScrollbarV: boolean; //true: fixed header and pagination of results
  IsFunctionalityNotImplemented: boolean; //if the functionality has not yet been implemented, show the app-error-component component
  ShowErrorContent: boolean; //if an error occurred it shows the app-error-component component
  IsApp: boolean; //false: WEB, true: APP
  IsListInitialized: boolean; //true: List initialized
  Reload: boolean; //true: The reload button is shown in the app-error-component component
  Sorts: SortInfo; //If set, it allows you to sort the rows of the table in a certain order
  RowHeight: any; //Indicates the size of the table rows
}

export class GatewayNameForTable {
  InstanceGUID: string;
  Name: string;
}

export class SortInfo {
  Prop: string;
  Direction: SortOrder;
}
